<template>
  <template v-if="!query || !hasMatch">{{ text }}</template>
  <template v-else>
    <template v-for="(seg, i) in segments" :key="i">
      <mark
        v-if="seg.match"
        class="bg-yellow-200 text-yellow-900 rounded-sm px-0.5 dark:bg-yellow-500/30 dark:text-yellow-200"
      >{{ seg.text }}</mark>
      <template v-else>{{ seg.text }}</template>
    </template>
  </template>
</template>

<script setup lang="ts">
import {computed} from 'vue';

const props = defineProps<{
  text: string;
  query: string;
}>();

interface Segment {
  text: string;
  match: boolean;
}

const segments = computed<Segment[]>(() => {
  const q = props.query.trim();
  if (!q || !props.text) return [{ text: props.text, match: false }];

  // Escape regex special characters
  const escaped = q.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const re = new RegExp(`(${escaped})`, 'gi');
  const parts = props.text.split(re);

  return parts
    .filter((p) => p.length > 0)
    .map((p) => ({
      text: p,
      match: p.toLowerCase() === q.toLowerCase(),
    }));
});

const hasMatch = computed(() => segments.value.some((s) => s.match));
</script>
